export const multipleEmailRule = extend => {
  extend('multiple_emails', {
    validate (value) {
      const emails = value.split(',')
      // eslint-disable-next-line no-useless-escape
      const tester = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      let result = true

      for (let i = 0; i < emails.length; ++i) {
        if (!tester.test(emails[i].trim().toLowerCase())) {
          result = false
          break
        }
      }

      return result
    }
  })
}

export const multipleEmailMessage = {
  en: {
    multiple_emails: 'The {_field_}  must must only have valid email addresses'
  },
  nl: {
    multiple_emails: 'De {_field_} mag alleen geldige e-mailadressen hebben'
  },
  de: {
    multiple_emails: 'Das {_field_} muss nur gültige E-Mail-Adressen haben'
  },
  es: {
    multiple_emails: 'El {_field_} solo debe tener direcciones de correo electrónico válidas'
  },
  fr: {
    multiple_emails: 'Le {_field_} ne doit avoir que des adresses e-mail valides'
  }
}
